/*
 * toolbox.ts
 * Gegenereerd met Junie (AI), 25-5-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Model voor de toolbox-tabel: een document met titel en inhoud dat door personeelsleden goedgekeurd moet worden.
 */

import {Basemodel, ModelField, ModelRelation} from './basemodel';
import {PersoneelvastToolbox} from './personeelvast_toolbox';

export class Toolbox extends Basemodel {
  static override table = 'toolbox';

  @ModelField() override id: number = null;
  @ModelField() titel: string = '';
  /** Quill-delta als JSON-string */
  @ModelField() inhoud: string;
  @ModelField() actief: boolean = true;
  @ModelField() begindatum: string = null;
  @ModelField() einddatum: string = null;
  /** Array van functie_id's die de doelgroep bepalen */
  @ModelField() functie_ids: number[] = null;
  /** array van personeelslabels die de doelgroep bepalen */
  @ModelField() labels: string[] = null;
  @ModelField() createdAt: string = null;
  @ModelField() updatedAt: string = null;

  @ModelRelation({model: PersoneelvastToolbox}) personeelvast_toolbox: PersoneelvastToolbox[] = [];

  override get recordbeschrijving(): string {
    return this.titel;
  }
}
